import * as moment from 'moment-timezone';
import * as DBT from "../api/models/db-types";
import { Injectable } from '@angular/core';
import { MPT } from '../domain/contexts/mpt';
import { WhitelabelService } from '../domain/whitelabel.service';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {
  
  private timezone: string;
  
  constructor(
      private whiteLabel: WhitelabelService,
  ) { 
    if (this.whiteLabel.context === MPT.id) {
      this.timezone = this.whiteLabel.contextData.defaultTimezone; // 'America/Toronto' 
    } else {
      this.timezone = moment.tz.guess();
    }
  }
  
  getTimezone() {
    return this.timezone;  
  }
  
  /**
   * This function takes a timestamp with a UTC assumption and convert it to the America/Toronto (EST/EDT) timezone for display
   * @param datetime UTC timestamp
   * @returns a moment object of the timestamp converted to the America/Toronto (EST/EDT) timezone
   */
  moment(datetime: string | DBT.DATETIME | number): moment.Moment {
    return moment.utc(datetime).tz(this.timezone);
  }
  
  /**
   * This function takes a timestamp in local timezone and convert it to UTC in the same format
   * @param datetime 
   * @param format 
   * @returns 
   */
  localToUTC(datetime: string | DBT.DATETIME | number, format?: string): string {
    return moment.tz(datetime, format, this.timezone).utc().format(format);
  }
  
  /**
   * This function parses a datetime value using the specified format in the application's timezone
   * @param datetime 
   * @param inputFormat 
   * @param outputFormat 
   * @returns 
   */
  toLocalTime(datetime: string | DBT.DATETIME | number, inputFormat?: string, outputFormat?: string): string {
    return moment.tz(datetime, inputFormat, this.timezone).format(outputFormat);
  }

}
